export default __webpack_public_path__ + "static/Integrant_Labs_Logo_Text_Light-b5dbf11e5eda1b25bb52feeb9ea8eeac.png";